import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getHealthSolutionCategory = ({ urlSlug }) =>
  call(websocketFetch, 'get_health_solution_category', {
    url_slug: urlSlug,
  });
